// extracted by mini-css-extract-plugin
export default {"menuTitle":"ActiveItem_menuTitle__gMLV2","menuDesc":"ActiveItem_menuDesc__WHbka","menuItem":"ActiveItem_menuItem__XAo7P","menuItemChild":"ActiveItem_menuItemChild__Wy+zG"};